import { createStitches as q } from '../../../../../common/temp/node_modules/.pnpm/@stitches_react@1.2.8_react@17.0.2/node_modules/@stitches/react/dist/index.mjs.js';
import { media } from './config/media.js';
import { utils } from './config/utils.js';
const {
  config,
  css,
  getCssText,
  keyframes,
  styled
} = q({
  media,
  utils
});
export { config, css, getCssText, keyframes, styled };